import React from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import './GettingCoveredSteps.scss';

export default function GettingCoveredSteps() {

  const steps = [
    {
      name: "Select Coverage",
      descr: "Tell us a little about yourself and what you're looking for. You can let us know what you need, or we can help you decide.",
    },
    {
      name: "Quote and Apply",
      descr: "We'll search on your behalf so you can select the best product for your needs with the best available rates. You can apply online in as little as a few minutes.",
    },
    {
      name: "Purchase Policy",
      descr: "Once the carrier makes you an offer, you can accept, purchase and receive your policy right then - online, same-day. It's life insurance made simple.",
    },
  ]
  return (
    <Row className="getting-covered-steps justify-content-center">
      <Col className="content-section">
        <Col className="text-center">
          <h2>Getting covered is simple</h2>
        </Col>
        <Row>
          <Col md={{ span: 6, order: 'last' }} className="steps-section flex-basis-50">
            <ol>
              {steps.map((step, index) => <li className="stepListItem" key={index}>
                <h3 className='text-start'>{step.name}</h3>
                <p>{step.descr}</p>
              </li>)}
            </ol>
          </Col>
          <Col md={{ span: 6, order: 1 }} className="left-side d-flex align-items-center justify-content-center flex-basis-50">
            <Image src="home/tablet2.png" alt="" />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
